import React, { useState, useEffect } from "react";
import "./UploadTab.css"; // ✅ Importa tu hoja de estilos

export default function UploadTab({ patientId, type }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [files, setFiles] = useState([]);
  const [loadingFiles, setLoadingFiles] = useState(true);

  // 📂 Cargar archivos existentes al montar
  useEffect(() => {
    const loadFiles = async () => {
      try {
        const response = await fetch(
          `https://te-ayudo.es/back/api/list_patient_files.php?patient_id=${patientId}`
        );
        const data = await response.json();
        if (data.ok) {
          const filtered = data.files.filter((f) => f.file_type === type);
          setFiles(filtered);
        } else {
          console.error("Error al obtener archivos:", data.error);
        }
      } catch (err) {
        console.error("Error al cargar archivos:", err);
      } finally {
        setLoadingFiles(false);
      }
    };

    loadFiles();
  }, [patientId, type]);

  // 📤 Cuando el usuario selecciona un archivo
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setMessage("");
    setUploadedFile(null);
  };

  // 🚀 Subir archivo a Drive
  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Selecciona un archivo primero.");
      return;
    }

    setUploading(true);
    setMessage("Subiendo archivo...");

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("patient_id", patientId);
    formData.append("type", type);

    try {
      const response = await fetch("https://te-ayudo.es/back/api/upload_drive.php", {
        method: "POST",
        body: formData,
      });

      const text = await response.text();
      const data = JSON.parse(text);

      if (response.ok && data.ok) {
        setMessage(`✅ Archivo subido correctamente: ${data.file?.name || ""}`);
        setUploadedFile(data.file);
        setSelectedFile(null);

        // 🔄 Recargar lista
        const res = await fetch(
          `https://te-ayudo.es/back/api/list_patient_files.php?patient_id=${patientId}`
        );
        const list = await res.json();
        if (list.ok) {
          const filtered = list.files.filter((f) => f.file_type === type);
          setFiles(filtered);
        }
      } else {
        throw new Error(data.error || "Error desconocido al subir el archivo.");
      }
    } catch (err) {
      console.error("❌ Error al subir archivo:", err);
      setMessage(`❌ Error al subir: ${err.message}`);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="upload-tab">
      <h4>
        📁 {type === "otros" ? "Otros documentos" : "Contratos"} del paciente
      </h4>

      {/* Selector de archivo */}
      <input
        type="file"
        onChange={handleFileChange}
        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
      />

      {selectedFile && (
        <p className="selected-file">
          <strong>Archivo seleccionado:</strong> {selectedFile.name}
        </p>
      )}

      {/* Botón subir */}
      <button
        className="upload-btn"
        onClick={handleUpload}
        disabled={uploading || !selectedFile}
      >
        {uploading ? "Subiendo..." : "Subir a Drive"}
      </button>

      {message && (
        <p className={`message ${message.includes("❌") ? "error" : "success"}`}>
          {message}
        </p>
      )}

      {/* 🧩 Enlace directo del último archivo subido */}
      {uploadedFile && uploadedFile.webViewLink && (
        <div className="uploaded-file-box">
          <p>
            <strong>Archivo en Google Drive:</strong> {uploadedFile.name}
          </p>
          <a
            href={uploadedFile.webViewLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            🔗 Ver en Google Drive
          </a>
        </div>
      )}

      {/* 📄 Lista de archivos ya subidos */}
      <div className="uploaded-files-list">
        <h5>📄 Archivos ya subidos</h5>

        {loadingFiles ? (
          <p>Cargando archivos...</p>
        ) : files.length === 0 ? (
          <p>No hay archivos subidos todavía.</p>
        ) : (
          <ul>
            {files.map((f) => (
              <li key={f.id}>
                <a
                  href={f.drive_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {f.file_name}
                </a>
                <br />
                <small>
                  {f.file_type} — {new Date(f.uploaded_at).toLocaleString()}
                </small>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
